import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ffc865ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page__hd" }
const _hoisted_2 = {
  key: 0,
  class: "page__title"
}
const _hoisted_3 = { class: "swiper-container gallery-container animation-image" }
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination gallery-pagination" }, null, -1))
const _hoisted_7 = { class: "weui-gallery__opr" }
const _hoisted_8 = {
  key: 0,
  role: "button",
  "aria-label": "删除",
  href: "javascript:",
  class: "weui-gallery__del"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page", _ctx.visible? 'page-visible': 'page-unvisible'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "weui-gallery gallery-content",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgs, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "swiper-slide",
              key: index,
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("img", {
                src: item,
                class: "banner-img"
              }, null, 8, _hoisted_5)
            ]))
          }), 128))
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isShowDel)
          ? (_openBlock(), _createElementBlock("a", _hoisted_8, " 关闭 "))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}